module.exports = __webpack_public_path__ + "img/people.4c9671ad.svg";